import React, { useState, useRef, useEffect }  from 'react'
import './Transportation.css'
import { GoogleMap, Marker, Autocomplete, DirectionsRenderer, LoadScript } from '@react-google-maps/api'
import BusIcon from '../../assets/BusIcon.png'
import DetailsIcon from '../../assets/DetailsIcon.png'
import VehicleTitleIcon from '../../assets/VehicleTitleIcon.png'
import LocationMarkIcon from '../../assets/LocationMarkIcon.png'
import SchoolBusIcon from '../../assets/SchoolBusIcon.png'
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function Transportation() {
  const [map, setMap] = React.useState(null)

  //map toggle on topbar
  const [displayMap, setDisplayMap] = useState(true)
  //get list of vehicles
  const [vehicleList, setVehicleList] = useState([
    { id: 1, name: 'Bus-1', routeId:'rid123', driverId:'did123', 
      currentLocation: {lat: 17.8548,lng: 79.3775}, lastdrop: '10 Min ago' },
    { id: 2, name: 'Bus-2', routeId:'rid234', driverId:'did234', 
      currentLocation: {lat: 17.6437, lng: 79.0430}, lastdrop: '30 Min ago' },
    { id: 3, name: 'Bus-3', routeId:'rid345', driverId:'did345', 
      currentLocation: {lat: 17.4511, lng: 78.6810},
      lastdrop: '1 hour ago' },
    { id: 4, name: 'Bus-4', routeId:'rid456', driverId:'did456', 
      currentLocation: {lat: 17.5892, lng: 78.9448},
      lastdrop: '1 hour ago' },
  ]);
  //whether vehicle selected or not
  const [selectedVehicle, setSelectedVehicle] = useState(false)
  //selected vehicle details
  const [vehicleDetails, setVehicleDetails] = useState({ id: '', name: '', routeId:'', driverId:'', lastdrop: '' })
  //handle vehicle selection    
  const handleVehicleSelect = (e, vehicle) => {
      e.preventDefault();
      setSelectedVehicle(true)
      setVehicleDetails(vehicle)
  };
  //selecting driver or route tabs
  const [activeTab, setActiveTab] = useState('tabDriver');
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  }
  //route
  const [route, setRoute] = useState({})
  const [routeList, setRouteList] = useState([
    {id: 'rid123',
        origin: {
          name:'Warangal',
          time:'11:00',
          location: {lat:17.968901,lng: 79.594055}, 
          students: [
            {name: 'Subash' , id: 'id001', class: '1A'},
            {name: 'Bhagat' , id: 'id002', class: '1B'},
            {name: 'Tilak' , id: 'id003', class: '1B'}
          ]
        },
        destination: {
          name:'Hyderabad',
          time:'14:00',
          location:{lat: 17.4065,lng: 78.4772},
          students: [
            {name: 'Gandhi' , id: 'id004', class: '10A'},
            {name: 'Nehru' , id: 'id005', class: '10B'},
            {name: 'Patel' , id: 'id006', class: '10C'},
          ]
        },
        stops: [
          { name:'Jangaon',
            time:'12:00',
            location:{ lat: 17.725300, lng: 79.154900},
            students: [
              {name: 'Tagore' , id: 'id007', class: '8A'},
              {name: 'Ambedkar' , id: 'id008', class: '8B'},
            ]
          },
          {
            name:'Bhongir',
            time:'13:00',
            location:{ lat: 17.515162, lng: 78.882523},
            students: [
              {name: 'Pandey' , id: 'id009', class: '5A'},
              {name: 'Azad' , id: 'id010', class: '5B'},
              {name: 'Naidu' , id: 'id011', class: '5C'}
            ]
          }
        ] //warangal-hyd:jangaon,bhongir
    },
    {id: 'rid234',
      origin: { lat: 17.968901, lng: 79.594055}, destination: { lat: 17.385044, lng: 17.385044},
        stops: [{ lat: 17.725300, lng: 79.154900},{ lat: 17.515162, lng: 78.882523}] //warangal
    },
    {id: 'rid345',
      origin: { lat: 17.968901, lng: 79.594055}, destination: { lat: 17.385044, lng: 17.385044},
        stops: [{ lat: 17.725300, lng: 79.154900},{ lat: 17.515162, lng: 78.882523}] //warangal
    },
  ])
  //get current locations
  const currentLocations = vehicleList.map(item => item.currentLocation)
  console.log(currentLocations)

  //set route as soon as vehicle is selected
  useEffect(()=>{
      console.log(vehicleDetails.routeId)
      setRoute(routeList.filter(item => item.id == vehicleDetails.routeId)[0])
  },[vehicleDetails])
  const [stopOrigin, setStopOrigin] = useState(false)
  const [stopDestination, setStopDestination] = useState(false)
  const [selectedStop, setSelectedStop] = useState('')
  //calculate route once route is set
  const [ origin, setOrigin ] = useState({})
  const [ destin, setDestin ] = useState({})
  const [ waypoints, setWaypoints ] = useState({})
  useEffect(()=>{
    if(route && route.origin ){
      setOrigin(route.origin.name)
      setDestin(route.destination.name)
      setWaypoints(route.stops.map(item => ({location:item.location})))
    }
  },[route])
  useEffect(()=>{
    calculateRoute()
  },[origin, destin])

  //MAP //////////////////////////////////////////
  const containerStyle = { width: '100%', height: '90%'};
  const center = { lat: 17.3850,lng: 78.4867};
  const onLoad = React.useCallback(function callback(map) {
    // const bounds = new window.google.maps.LatLngBounds(center);
    // map.fitBounds(bounds);
    setMap(map)
  }, [])
  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  const [ directionsResponse, setDirectionsResponse ] = useState(null)

  async function calculateRoute() {
    if( origin === '' || destin === '' ) {
      return
    }
    if (window.google && window.google.maps) {
      const directionsService = new window.google.maps.DirectionsService()
      const results = await directionsService.route({
      origin: origin,
      destination: destin,
      waypoints: waypoints,
      travelMode: window.google.maps.TravelMode.DRIVING 
      })
      setDirectionsResponse(results)

    }
  }
  const ListItem = ({ item, onItemClick, isSelected }) => {
    return (
      <div onClick={() => onItemClick(item)} className="vehicleName">
        {item.name}
        {isSelected && (
          <div>
            <p>{item.details}</p>
          </div>
        )}
      </div>
    );
  };
  
  const [selectedItem, setSelectedItem] = useState(null);
  
  const handleItemClick = (item) => {
    setSelectedItem(selectedItem === item ? null : item);
  };

  const apiKEY = 'AIzaSyBvwPMm17jKBm9pBJE5tS9w90gSmzpYoKA'  //orgAPI
  console.log(apiKEY)

  return (
    <div className="transportation">
      <div className="wrap-titlebox">
        <div className="left-title">
          <div className="logo-vehicle">
            <div><img src={VehicleTitleIcon} style={{height:"30px"}} /></div>
            <div className="title-vehicle">Vehicles</div>
          </div>
          <div className="status-vehicle">
            <span>Online</span>
            <span>10</span>
            <span className="vline"></span>
            <span>Offline</span>
            <span>6</span>
          </div>
        </div>
        <div className="right-title">
          <div><input type="text" placeholder='Search here' className="search-vehicle"></input></div>
          <div><button className="add-vehicle">Add Vehicle</button></div>
          <div className="wrap-mapicon"> 
            {displayMap && <button className="map-display" onClick={()=>setDisplayMap(!displayMap)} >
              <img src={LocationMarkIcon} style={{height:"20px"}}/> 
            </button>}
            <button className="bbox"></button>
            {!displayMap&&<button className="map-display" onClick={()=>setDisplayMap(!displayMap)} >
              <img src={LocationMarkIcon} style={{height:"20px",filter:"grayscale(100%)"}}/>
            </button>}
          </div>
          <button className="reload-map"><RefreshIcon/></button>
        </div>
      </div>
      <div className="wrap-content">
        {/* Vehicle List */}
        {!selectedVehicle &&<div className="wrap-vehicles">
          {vehicleList.map((item, index) => (
            <button className="vehicle-box" key={index} onClick={(e)=>handleVehicleSelect(e,item)}>
              <div className="wrap-busbox">
                <div className="bus-box">
                  <img src={BusIcon} style={{height:"40px"}}/>
                  <span>{item.name}</span>
                </div>
                <div className="wrap-signbus">
                  <img src={DetailsIcon} style={{height:"20px"}}/>
                </div>
              </div>
              <div className="lastdrop"> Last Drop: {item.lastdrop}</div>
              <div className="check-location">Check location on the map</div>
            </button>
          ))}
        </div>}

        {/* Selected Vehicle */}
        {selectedVehicle && <div className="wrap-vehicleInfo">
          <div className="vehicle-name">
            <button onClick={()=>setSelectedVehicle(false)}><ArrowBackIcon style={{fontSize:"18px",verticalAlign:"center"}}/></button>
            <span>{vehicleDetails.name}</span>
          </div>
          <div className="vinfo-tabs">
            <button className={`${activeTab === 'tabDriver' ? 'selected-vtab' : 'vtab'}`} onClick={() => handleTabClick('tabDriver')}>Driver Info</button>
            <button className={`${activeTab === 'tabRoute' ? 'selected-vtab' : 'vtab'}`} onClick={() => handleTabClick('tabRoute')}>Route & Students</button>
          </div>
          {(activeTab === 'tabDriver')&&<div className="driver-info">
            <div className="key-dinfo">Driver ID</div>
            <div className="value-dinfo">{vehicleDetails.driverId}</div>
            <div className="key-dinfo">Driver Name</div>
            <div className="value-dinfo">Raviteja</div>
            <div className="key-dinfo">Contact</div>
            <div className="value-dinfo">9000123456</div>
            <div className="bus-info">
              <div><img src={SchoolBusIcon} style={{height:"50px"}}></img></div>
              <div className="item-businfo">
                  <span className="key-businfo">Model: </span>
                  <span></span>
              </div>
              <div className="item-businfo">
                  <span className="key-businfo">Fuel Efficiency: </span>
                  <span></span>
              </div>
              <div className="item-businfo">
                  <span className="key-businfo">Color: </span>
                  <span></span>
              </div>
              <div className="item-businfo">
                  <span className="key-businfo">Capacity: </span>
                  <span></span>
              </div>
              <div className="item-businfo">
                  <span className="key-businfo">Vehicle Type: </span>
                  <span></span>
              </div>
              <div className="item-businfo">
                  <span className="key-businfo">Mileage: </span>
                  <span></span>
              </div>
              <div className="item-businfo">
                  <span className="key-businfo">Manufacturing Year: </span>
                  <span></span>
              </div>
            </div>
          </div>}
          {(activeTab === 'tabRoute')&&<div>
            <div>
            <div className="route-row origin-row" onClick={()=>{setStopOrigin(!stopOrigin)}}>
              <div className="route-item">
                <span>A</span>
                <span>{route.origin.name}</span>
                <span>{route.origin.time}</span>
              </div>
              <div><ExpandMoreIcon/></div>
            </div>
            {stopOrigin &&<div>
              {route.origin.students.map((item, index) => (
                <div className="student-row">
                  <span>{item.name}</span>
                  <span>{item.id}</span>
                  <span>{item.class}</span> 
                </div>  
              ))}
              </div>}
            </div>

            {route.stops.map((item, index) => ( 
              <div>
              <div className="route-row stop-row" onClick={()=>{if(selectedStop){setSelectedStop('')}else{setSelectedStop(index+1)}}}>
                <div className="route-item">
                  <spanS>{String.fromCharCode(66+index)}</spanS>
                  <span>{item.name}</span>
                  <span>{item.time}</span>
                </div>
                <div><ExpandMoreIcon/></div>
              </div>
              {(selectedStop-1 === index)&&<div>
                {item.students.map((item, index) => (
                <div className="student-row">
                  <span>{item.name}</span>
                  <span>{item.id}</span>
                  <span>{item.class}</span> 
                </div>  
                ))} 
                </div>}
              </div>
            ))}

            <div>
              <div className="route-row destination-row" onClick={()=>{setStopDestination(!stopDestination)}}>
                <div className="route-item">
                <spanS>{String.fromCharCode(66+route.stops.length)}</spanS>
                  <spam>{route.destination.name}</spam>
                  <span>{route.destination.time}</span>
                </div>
                <div><ExpandMoreIcon/></div>
              </div>
              {stopDestination&&<div>
              {route.destination.students.map((item, index) => (
                <div className="student-row">
                  <span>{item.name}</span>
                  <span>{item.id}</span>
                  <span>{item.class}</span> 
                </div>  
                ))} 
              </div>}
            </div>
          </div>}
        </div>}

        {/* Map */}
        <div className="wrap-map">

          <LoadScript id='google-map-script' googleMapsApiKey={apiKEY} libraries={['places']}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center} 
              zoom={8}
              onLoad={onLoad}
              onUnmount={onUnmount}
              options={{
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false
              }}
            >
              { /* Child components, such as markers, info windows, etc. */ }
              {currentLocations && currentLocations.map((point, index)=>(
                <Marker key={index} position={point} /> 
              ))}
              {directionsResponse && <DirectionsRenderer directions={directionsResponse}/>}
            </GoogleMap>
          </LoadScript>
        </div>

      </div>
    </div>
      
  ) 
}

export default React.memo(Transportation)